export const formatPhoneNumberToDash = (value)=>{
    if (!value) return "";
    // 숫자만 추출
    const numbers = value.replace(/\D/g, "");
    // 서울 지역번호 (02)인지 확인
    const isSeoul = numbers.startsWith("02");
    if (numbers.length <= 3) {
        return numbers;
    }
    if (numbers.length <= 6) {
        return "".concat(numbers.slice(0, 3), "-").concat(numbers.slice(3));
    }
    if (numbers.length <= 9) {
        return isSeoul ? "02-".concat(numbers.slice(2, 5), "-").concat(numbers.slice(5)) // 02-XXX-XXXX
         : "".concat(numbers.slice(0, 3), "-").concat(numbers.slice(3, 6), "-").concat(numbers.slice(6)) // XXX-XXX-XXX
        ;
    }
    if (numbers.length === 10) {
        return isSeoul ? "02-".concat(numbers.slice(2, 6), "-").concat(numbers.slice(6)) // 02-XXXX-XXXX
         : "".concat(numbers.slice(0, 3), "-").concat(numbers.slice(3, 6), "-").concat(numbers.slice(6)) // XXX-XXX-XXXX
        ;
    }
    if (numbers.length === 11) {
        // 11자리 (휴대폰)
        return "".concat(numbers.slice(0, 3), "-").concat(numbers.slice(3, 7), "-").concat(numbers.slice(7)) // XXX-XXXX-XXXX
        ;
    }
    if (numbers.length === 12) {
        // 12자리 (4-4-4 형식)
        return "".concat(numbers.slice(0, 4), "-").concat(numbers.slice(4, 8), "-").concat(numbers.slice(8)) // XXXX-XXXX-XXXX
        ;
    }
    if (numbers.length === 13) {
        // 13자리 (3-5-5 형식)
        return "".concat(numbers.slice(0, 3), "-").concat(numbers.slice(3, 8), "-").concat(numbers.slice(8)) // XXX-XXXXX-XXXXX
        ;
    }
    // 14자리 이상 (기본 3-4-4 형식)
    return "".concat(numbers.slice(0, 3), "-").concat(numbers.slice(3, 7), "-").concat(numbers.slice(7, 11));
};
export const formatDashPhoneNumberToNumber = (value)=>{
    if (!value) return "";
    const numbers = value.replace(/-/g, "");
    return numbers;
};
